package com.eladfinish.bible.contest.screens.browse.usecases.shonot

import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.VerseReferenceCV
import com.eladfinish.bible.contest.screens.browse.usecases.GetContentUseCase
import com.eladfinish.bible.contest.utils.beautifyText

class GetRoshChodeshContentUseCase(
    private val getContentUseCase: GetContentUseCase,
) {
    operator fun invoke(): String {
        return getContentUseCase.getContent(
            bookIndex = 4,
            bookName = "bamidbar",
            currentChapter = 28,
            startVerseReferenceCV = VerseReferenceCV(chapter = 28, verse = 1),
            endVerseReferenceCV = VerseReferenceCV(chapter = 28, verse = 15),
            onlyQri = true,
        ).beautifyText()
    }
}
